import { render, staticRenderFns } from "./MedicalRecordsTable.vue?vue&type=template&id=1956ff7e&scoped=true&"
import script from "./MedicalRecordsTable.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordsTable.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordsTable.vue?vue&type=style&index=0&id=1956ff7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956ff7e",
  null
  
)

export default component.exports